import React, { PureComponent } from 'react'
import { Field, reduxForm } from 'redux-form'
import { TextField } from 'redux-form-material-ui'
import { required } from '../../form/validation'
import FlatButton from 'material-ui/FlatButton'
import Send from 'material-ui/svg-icons/content/send'

class RejectSwapForm extends PureComponent {
  render() {
    const { handleSubmit, submitting, toggleOpen } = this.props
    return (
      <form onSubmit={handleSubmit}>

        <div>
          <Field
            name="reason"
            component={TextField}
            disabled={submitting}
            validate={[required]}
            hintText="Motivazione"
            floatingLabelText="Inserisci una motivazione"
            multiLine={true}
            fullWidth={true}
            rows={2}
          />
        </div>

        <div style={{ overflow: 'auto', marginTop: '40px' }}>
          <FlatButton
            type="submit"
            disabled={submitting}
            label="OK"
            primary={true}
            icon={<Send />}
            style={{ float: 'right', marginRight: 10 }}
          />
          <FlatButton
            type="button"
            label="Annulla"
            secondary={true}
            onClick={toggleOpen}
            style={{ float: 'left', marginLeft: 10 }}
          />
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'reject-swap-form',
})(RejectSwapForm)



// WEBPACK FOOTER //
// ./src/common/Swap/RejectSwapForm.js